import React from "react";
import Grid from "@mui/material/Grid";
import Header from "./components/Header";
import * as styles from "./LayoutStyles";
import { Outlet } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Footer from "./components/Footer";
import "./layout.css";
import { useSelector } from "react-redux";

const Layout = ({ children }) => {
  const { menuOpen } = useSelector((storeState) => storeState.menu);
  const { isLoggedIn } = useSelector((state) => state.auth);

  return (
    <Grid container>
      {/* Header */}
      <Grid container item xs={12} sx={styles.headerGridContainer}>
        <Header />
      </Grid>

      {/* body */}
      <Grid container item xs={12} sx={styles.bodyGridContainer()}>
        {/* Left Menu */}
        <Grid
          hidden={!menuOpen}
          item
          xs={12}
          sm={4}
          md={3}
          lg={2}
          sx={styles.leftMenuGridItem()}
        >
          {isLoggedIn && <Sidebar />}
        </Grid>
        {/* Content */}
        <Grid
          item
          xs={12}
          sm={menuOpen ? 8 : 12}
          md={menuOpen ? 9 : 12}
          lg={menuOpen ? 10 : 12}
          sx={styles.contentGridItem()}
        >
          {children}
        </Grid>
        {/* Right Menu */}
      </Grid>

      <Grid item xs={12} sx={styles.footerGridItem}>
        <Footer />
      </Grid>
      <Outlet />
    </Grid>
  );
};
export default Layout;
